import { object } from 'prop-types'
import React from 'react'

import * as utils from '../../../external/utilities/GeneralUtils'
import Translation from '../../Translation'

const FacilityAlerts = ({ intl, facility }) => {
  const bulletins = facility.alerts.map((alert, key) => {
    let headline
    if (!utils.isEmpty(alert.headline)) {
      headline = <span className="facility-alert__title">{alert.headline}</span>
    }

    return (
      <div key={key} className="facility-alert__item">
        <div className="facility-alert__content">
          {headline}
          <span
            className="facility-alert__body"
            dangerouslySetInnerHTML={utils.htmlBlock(alert.content)}
          ></span>
        </div>
      </div>
    )
  })

  return (
    <div className="facility-alert">
      <div className="info-message__item">
        <div className="info-message__content">
          <Translation
            styleClass="info-message__title"
            intl={intl}
            mkey="labels_notes_alerts"
          />
        </div>
      </div>
      {bulletins}
    </div>
  )
}

FacilityAlerts.propTypes = {
  intl: object.isRequired,
  facility: object.isRequired,
}

export default FacilityAlerts
